import { API, BASE_URL } from "./API";
import { AppVersion } from "../models/AppVersion";

export const getLatestAppVersion = (): Promise<AppVersion> => {
  return API.get<AppVersion>(`apk/latest`);
};

export const getApkDownloadUrl = (versionId: number): string =>
  `${BASE_URL}apk/${versionId}/download`;
